// extracted by mini-css-extract-plugin
export var attachment = "_nf-a";
export var emailContainer = "_nf-4";
export var emailContentPaddedContainer = "_nf-b";
export var emailHeader = "_nf-6";
export var emailIframe = "_nf-3";
export var emailInfoIcon = "_nf-9";
export var emailShortenedSummary = "_nf-e";
export var infoDropdown = "_nf-0";
export var infoRowBoundedContent = "_nf-d";
export var internal = "_nf-5";
export var merchant = "_nf-8";
export var messageInputContainer = "_nf-h";
export var normal = "_nf-7";
export var replyCard = "_nf-f";
export var subtleButton = "_nf-1";
export var subtleButtonIconContainer = "_nf-2";
export var toggleViewRepliesButton = "_nf-c";
export var wrappingText = "_nf-g";